require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/fn/get-iterator.js
// module id = 325
// module chunks = 0